<h1 mat-dialog-title>Erreur</h1>
<div mat-dialog-content class="error-list">
  <span *ngFor="let error of data">
    {{ error.message }}
  </span>
</div>